import routes from "constants/routes";
import { camelizeKeys } from "utils/camelizeKeys";
import { removeToken } from "utils/tokenUtils";

const HTTP_STATUS_MESSAGES = {
  400: "Invalid parameters provided",
  401: "Authentication required",
  403: "Access denied",
  404: "Resource not found",
  409: "Resource already exists",
  422: "Validation failed",
  429: "Too Many Requests - Rate limit exceeded",
  500: "Something went wrong, please try again later",
  502: "Something went wrong, please try again later",
  503: "Service Unavailable - Server maintenance",
  504: "Server took too long to respond, please try again later",
};

const extractErrorMessage = (response, json) => {
  if (!json)
    return HTTP_STATUS_MESSAGES[response.status] || "An unknown error occurred";
  if (Array.isArray(json.detail)) {
    return json.detail.map((err) => err.msg || "Unknown error").join(", ");
  }
  if (typeof json.detail === "string") return json.detail;
  if (json.message) return json.message;
  return HTTP_STATUS_MESSAGES[response.status] || "An unknown error occurred";
};

const fetchJSON = async (url, options = {}) => {
  const newOptions = {
    method: options.method,
    mode: "cors",
    headers: {
      ...options.headers,
    },
  };

  if (options.body) {
    if (options.body instanceof FormData) {
      newOptions.body = options.body;
    } else {
      newOptions.headers["Content-Type"] = "application/json";
      newOptions.body = JSON.stringify(options.body);
    }
  }

  try {
    const response = await fetch(url, newOptions);
    const json = await response.json().catch(() => null);

    if (!response.ok) {
      if (response.status === 401) {
        removeToken();
        window.location.href = `${routes.login.root}?redirect=${window.location.pathname}`;
        return;
      }

      const message = extractErrorMessage(response, json);

      const err = new Error(message);
      err.statusCode = response.status;
      err.statusText = response.statusText;
      err.data = json || null;
      throw err;
    }

    const parsed = json ? camelizeKeys(json) : {};
    return parsed.data || parsed;
  } catch (error) {
    if (error instanceof TypeError) {
      return Promise.reject({
        statusCode: 0,
        message: "Network error — please check your connection",
        data: null,
      });
    }

    return Promise.reject({
      statusCode: error.statusCode || 0,
      message: error.message || "Unexpected error occurred",
      data: error.data || null,
    });
  }
};

export default fetchJSON;
